/** Copy Media Lab — Bolsa de Valores Descentralizada × TNO Media Lab */
export const bvdMediaLabWho = {
  title: 'TNO Media Lab: producción en casa para la Bolsa de Valores Descentralizada',
  subtitle:
    'Programa, micros en rotativa, clips para redes y clips promocionales en YouTube — todo con audiencia dirigida a TNO Network.',
  description:
    'TNO Media Lab es el centro de producción de TNO Network. Para la Bolsa de Valores Descentralizada asumimos la producción del programa en nuestros estudios, micros en la rotativa 24/7, clips para redes y piezas promocionales en YouTube que empujan tráfico hacia la plataforma TNO Network.',
};

export const bvdMediaLabWhy = {
  title: '¿Por qué producir con TNO Media Lab?',
  description:
    'Un solo partner en TNO: cuatro bloques integrados, publicación en TNO Network, bonificación en Digest y modelo claro de comercialización — 30% a la radio si trae el cliente la bolsa; 50/50 si lo trae TNO.',
  ctaText: 'Agendar reunión',
};

export const bvdMediaLabBenefits = {
  overline: 'Producción TNO',
  title: 'Cuatro bloques, un plan mensual',
  subtitle:
    'Cada bloque cumple una función en el embudo: profundidad (programa), recordación (rotativa), alcance social (clips) y promoción (YouTube → TNO Network).',
  items: [
    {
      title: 'Programa en estudio (Bloque 1)',
      subtitle:
        'Producción del espacio principal en TNO Media Lab: grabación, edición y entrega lista para publicar en TNO Network.',
      colorKey: 'blue',
    },
    {
      title: 'Micros en rotativa (Bloque 2)',
      subtitle:
        'Piezas cortas integradas en la rotativa 24/7 de TNO Network para mantener la marca visible en la señal multiplataforma.',
      colorKey: 'teal',
    },
    {
      title: 'Clips para redes (Bloque 3)',
      subtitle:
        '12 clips por episodio para Instagram, LinkedIn, TikTok y X — incluidos en el paquete de clips del plan.',
      colorKey: 'amber',
    },
    {
      title: 'YouTube promocional (Bloque 4)',
      subtitle:
        '4 clips promocionales por episodio (Shorts y avances) que impulsan al programa en TNO Network — mismo paquete de $50 USD/mes.',
      colorKey: 'pink',
    },
  ],
};

export const bvdMediaLabValues = {
  overline: 'Valores del Lab',
  title: 'ADN de la producción',
  hideAdnHeading: true,
  subtitle:
    'Tecnología broadcast, claridad editorial en mercado de valores y un flujo mensual predecible desde el Media Lab de TNO.',
  items: [
    {
      title: 'Producción in-house',
      subtitle: 'Todo se produce en TNO Media Lab con estándar de la red.',
    },
    {
      title: 'Alcance + conversión',
      subtitle:
        'Rotativa y redes generan recordación; los clips promocionales de YouTube empujan audiencia a TNO Network.',
    },
    {
      title: 'Comercialización',
      subtitle:
        'Opcional: cliente de la bolsa → 30% para TNO; cliente de la radio → 50% bolsa y 50% TNO, por cada patrocinador cerrado.',
    },
    {
      title: 'Inversión clara',
      subtitle:
        '$230 USD mensuales: programa $100, rotativa $80 y paquete clips $50 (12 redes + 4 promocionales YouTube por episodio).',
    },
  ],
};

export const bvdMediaLabAreYouReady = {
  headline: 'Activemos la producción para la Bolsa de Valores Descentralizada',
  subheadline: '¿Listos para el primer ciclo mensual?',
  body:
    'Coordinemos calendario de grabación, micros a rotativa, clips para redes y clips promocionales en YouTube con destino TNO Network.',
  ctaPrimary: 'Quiero esta propuesta',
  ctaSecondary: 'TNO Media Lab',
  ctaSecondaryHref: '/medialab',
  whatsappNumber: '04123964576',
  footerText:
    '© TNO Network 2026 | Bolsa de Valores Descentralizada × TNO Media Lab | The Content Evolution.',
};
